var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("router-view"),
      _vm._v(" "),
      _vm.$store.getters.getIsShowModal
        ? _c("modal-alert", {
            attrs: {
              message: _vm.$store.getters.getModalMessage,
              modalWidth: _vm.$store.getters.getModalWidth
            },
            on: { close: _vm.closeModal }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.$store.getters.getIsShowMaintenanceModal
        ? _c("maintenance-modal", {
            attrs: { html: _vm.$store.getters.getMaintenanceExp },
            on: { close: _vm.closeMaintenanceModal }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.$store.getters.getIsShowVerifyPaymentModal
        ? _c("verify-payment-modal")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 